/*! @azure/msal-browser v4.28.1 2026-01-17 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.28.1";

export { name, version };
